import React from "react";

const ImageControls = ({ confidence, setConfidence }) => {
  return (
    <div
      style={{
        background: "white",
        borderRadius: "8px",
        padding: "25px",
        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
        border: "1px solid #e9ecef",
      }}
    >
      <h3
        style={{
          color: "#2c3e50",
          marginBottom: "20px",
          fontSize: "1.3rem",
          fontWeight: "500",
        }}
      >
        🎛️ Image Analysis Settings
      </h3>

      <div style={{ marginBottom: "20px" }}>
        <label
          style={{
            display: "block",
            marginBottom: "6px",
            fontWeight: "500",
            color: "#555",
            fontSize: "0.95rem",
          }}
        >
          Confidence Threshold: {confidence}
        </label>
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <input
            type="range"
            min="0.1"
            max="1.0"
            step="0.1"
            value={confidence}
            onChange={(e) => setConfidence(parseFloat(e.target.value))}
            style={{
              flex: 1,
              height: "4px",
              borderRadius: "2px",
              background: "#ddd",
              appearance: "none",
              outline: "none",
            }}
          />
          <span
            style={{
              minWidth: "40px",
              textAlign: "center",
              fontWeight: "500",
              color: "#666",
            }}
          >
            {confidence}
          </span>
        </div>
      </div>

      <div
        style={{
          background: "#f8f9fa",
          padding: "20px",
          borderRadius: "6px",
          border: "1px solid #e9ecef",
        }}
      >
        <h4 style={{ marginBottom: "15px", color: "#2c3e50" }}>
          📋 Instructions
        </h4>
        <ul
          style={{
            color: "#666",
            fontSize: "0.9rem",
            lineHeight: 1.6,
            paddingLeft: "20px",
          }}
        >
          <li>Upload clear medical images (JPG, PNG, JPEG)</li>
          <li>Higher confidence = fewer but more accurate detections</li>
          <li>
            Lower confidence = more detections but may include false positives
          </li>
          <li>Recommended confidence: 0.7 for general use</li>
        </ul>
      </div>
    </div>
  );
};

export default ImageControls;
